module.exports = __webpack_public_path__ + "static/media/filter.ebc2e2d9.svg";